/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6f929425bf3fda1266399367274561a64188926f";
